if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    // NATUROTHEKE: Das Cart-Element wird im Konstruktor gecacht. Wird das
    // Custom Element <cart-drawer> zu diesem Zeitpunkt noch nicht "upgraded"
    // (z. B. weil ein App-Skript cart-drawer.js verzoegert oder blockiert),
    // fehlen ihm getSectionsToRender/renderContents. Der urspruengliche Code
    // ist dann beim Klick mit einem TypeError abgebrochen — ohne sichtbare
    // Reaktion. Deshalb hier zur Klickzeit erneut suchen und pruefen.
    getCart() {
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (!cart) return null;
      if (typeof cart.getSectionsToRender !== 'function' || typeof cart.renderContents !== 'function') {
        console.warn('[product-form] Cart-Element ist nicht initialisiert — es wird zur Warenkorbseite weitergeleitet.');
        return null;
      }
      return cart;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      const spinner = this.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      // NATUROTHEKE: zur Klickzeit aufloesen statt den Konstruktor-Cache nutzen.
      this.cart = this.getCart();

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.renderCartSafely(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.renderCartSafely(response);
          }
        })
        .catch((e) => {
          // NATUROTHEKE: Fehler nicht mehr stumm verschlucken — vorher sah ein
          // fehlgeschlagener Klick fuer den Kunden nach "nichts passiert" aus.
          console.error(e);
          this.error = true;
          this.handleErrorMessage(window.naturoAddToCartError || 'Der Artikel konnte nicht hinzugefügt werden. Bitte lade die Seite neu und versuche es erneut.');
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          const spinnerEl = this.querySelector('.loading-overlay__spinner');
          if (spinnerEl) spinnerEl.classList.add('hidden');
        });
    }

    // NATUROTHEKE: Scheitert das Nachrendern des Drawers, liegt der Artikel
    // trotzdem bereits im Warenkorb. Statt eines stummen Abbruchs wird dann
    // neu geladen, damit der Kunde seinen Artikel sieht.
    renderCartSafely(response) {
      try {
        this.cart.renderContents(response);
      } catch (error) {
        console.error('[product-form] Warenkorb konnte nicht aktualisiert werden:', error);
        window.location.reload();
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
